import { render, staticRenderFns } from "./PolicyHelpList4.vue?vue&type=template&id=563a8a09&"
import script from "./PolicyHelpList4.vue?vue&type=script&lang=js&"
export * from "./PolicyHelpList4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports